export function touchFields(form) {
  for (var property in form) {
    if (form[property] && form[property].$setTouched) {
      form[property].$setTouched();
    }
  }
}

export function validate(form) {
  touchFields(form);
  return form.$invalid;
}

export function checkRangeDate(before, after) {
  return before < after;
}

export function fechaRenderer(value) {
  if ((typeof value === 'string' || value instanceof String) && value.split(' ').length === 2) {
    return value;
  }

  return value ? moment(new Date(value)).format('DD/MM/YYYY') : '<i>No establecido</i>';
}

export function fechaHoraRenderer(value) {
  if ((typeof value === 'string' || value instanceof String) && value.split(' ').length === 2) {
    return value;
  }

  return value ? moment(new Date(value)).format('DD/MM/YYYY HH:mm') : '<i>No establecido</i>';
}

export function horaRenderer(value) {
  if ((typeof value === 'string' || value instanceof String) && value.split(' ').length === 2) {
    return value.split(' ')[1];
  }

  return value ? moment(new Date(value)).format('hh:mm') : '<i>No iniciado</i>';
}

export function pad(num, size) {
  var s = '00000000000' + num;
  return s.substr(s.length - size);
}

export function notEmpty(object) {
  return Object.keys(object).length;
}

export function formatErrorMessage(message) {
  if (message && message.length && message.forEach) {
    let messages = '';
    message.forEach(function(element) {
      messages += `'${element.property}': ${element.message}<br>`;
    });
    message = messages;
  }
  return message;
}


const removeAccents = function (string) {
  const accents =
    'ÀÁÂÃÄÅĄàáâãäåąßÒÓÔÕÕÖØÓòóôõöøóÈÉÊËĘèéêëęðÇĆçćÐÌÍÎÏìíîïÙÚÛÜùúûüÑŃñńŠŚšśŸÿýŽŻŹžżź';
  const accentsOut =
    'AAAAAAAaaaaaaaBOOOOOOOOoooooooEEEEEeeeeeeCCccDIIIIiiiiUUUUuuuuNNnnSSssYyyZZZzzz';
  return string
    .split('')
    .map((letter, index) => {
      const accentIndex = accents.indexOf(letter);
      return accentIndex !== -1 ? accentsOut[accentIndex] : letter;
    })
    .join('');
};

export function compare(value1, value2) {
  let toCompare = removeAccents(value1).toLowerCase();
  let compared = removeAccents(value2).toLowerCase();
  return toCompare.includes(compared);
}




// WEBPACK FOOTER //
// ./src/core/util/form.js